import { Quote } from "lucide-react";

/** Editorial pull quote lifted from the body copy. */
export function PullQuote({ text, attribution }: { text: string; attribution?: string | null }) {
  if (!text) return null;
  return (
    <figure className="my-10 border-y border-hairline py-8 text-center sm:px-6">
      <Quote className="mx-auto mb-4 h-6 w-6 text-brand" aria-hidden />
      <blockquote className="font-serif text-[1.45rem] font-medium italic leading-snug tracking-tight text-foreground sm:text-[1.7rem]">
        “{text}”
      </blockquote>
      {attribution ? (
        <figcaption className="mt-4 text-sm font-medium italic text-ink-muted font-serif">
          {attribution}
        </figcaption>
      ) : null}
    </figure>
  );
}
